<template>
  <div class="operacoes_container">
    <!-- Renderizando botões com base no array "buttons" -->
    <button
      v-for="button in buttons"
      :key="button.id"
      @click="selecionarMenu(button.id)"
      class="operacoes_button"
      v-show="funcaoPorROle.verificarFuncao(button.id)" 
      :class="{ botao_selected: userSelectedBottom == button.id }"
    >
      {{ button.text }}
    </button>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import funcaoPorROle from '../../../utilitarios/funcao.untilitario'
const ls = require("local-storage");
export default {
  data() {
    return {
      funcaoPorROle: funcaoPorROle,
      menuSelected: 0,
      buttons: [
        { id: 2, text: "Cadastrar Cliente" },
        { id: 3, text: "Consultar Pagamentos" },
        { id: 10, text: "Novo Pagamento" },
      ]
    };
  },

  computed: {
    nivel_user() {
      return ls.get("nivel_user");
    }
  },

  props: {
    userSelectedBottom: undefined
  },

  methods: {
    selecionarMenu(opcao) {
      try {
        this.menuSelected = opcao;
        this.$emit("selectedOptionMenu", opcao)
      } catch (error) {
        Swal.fire('Informação', 'Erro ao selecionar o menu', 'error')
      }
    },
  },
};
</script>

<style scoped>
.operacoes_container {
  padding: 5px 15px;
  margin: 10px auto;
  background-color: #fff;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-bottom: 5px;
}

.operacoes_button {
  background-color: #efefef;
  border: 1px solid #8795a2;
  color: #656565;
  display: inline-flex;
  align-items: center;
  padding: 5px 10px;
  margin-right: 10px;
  font-family: Montserrat;
  font-weight: 500;
  font-size: 12px;
  line-height: 17px;
  cursor: pointer;
  flex: 0 0 auto;
  margin-bottom: 10px;
  border-radius: 8px;
  flex-direction: row-reverse;
  height: auto;
}

.botao_selected {
  background-color: #c4d5e1;
}
</style>
